<template>
  <tr @click="$emit('update:expanded', !expanded)"
      :class="[
        item.isException ? 'exception-shipment' : '',
        compact ? 'compact-row' : ''
      ]" 
      :style="(item.applyForCancelShipment && !item.deleteTime) ? 'background-color: yellow' : ''"
  >
    <td
      v-if="!isHideCheckBox && isWarehouse && ['active', 'history'].includes(type)"
      @click.stop="props.selected = !props.selected"
    >
      <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
    </td>
    <td class="text-xs-center" v-if="index !== undefined">{{ index + 1 }}
      <v-icon 
      small
      v-if="isWarehouse && !isHideStar"
      :color="item.isCollection ? 'red' : ''"
      @click.stop="toggleHighlight(item)"
    >
      star
    </v-icon>
      
    </td>
    <td class="text-xs-left" style="white-space: nowrap">
      <v-layout v-if="isOrganization"
        ><strong>{{ $t('user') }}:&nbsp;</strong>{{ item.userName }}</v-layout
      >
      <v-layout v-else><strong>Org:&nbsp;</strong><a @click.stop="$emit('clickOrgId', getOrgId(item.tenantKey))">{{ getOrgId(item.tenantKey) + ` (${item.tenantName})` }}</a></v-layout>
      <v-layout><strong>ID:&nbsp;</strong>{{ item._key }}</v-layout>
      <v-layout v-if="isOrganization && type === 'active'"
        ><strong>{{ $t('type') }}:&nbsp;</strong>{{ $t('shipment') }}</v-layout
      >
      <v-layout v-if="(isOrganization || isWarehouse) && siteName"
        ><strong>{{ $t('site') }}:&nbsp;</strong>{{ siteName }}</v-layout
      >
    </td>
    <td class="text-xs-left" style="white-space: nowrap">
      <v-layout >
        <v-layout>
          {{ $t(item.isExpedited ? 'expedited' : 'normal') }}
        </v-layout>
        <v-layout row wrap>
          <p v-if="item.isTechShipment" style="color: red;font-weight: bold; font-size: 1.2rem">K</p>
        </v-layout>
        <v-tooltip top v-if="item.isPrinted && isOrganization && !item.deleteTime">
          <template v-slot:activator="data">
            <div v-on="data.on"><v-icon small>{{item.applyForCancelShipment ? 'delete' : 'lock'}}</v-icon></div>
          </template>
          <span>{{ item.applyForCancelShipment ? $t('cancellationRequestSubmitted') : $t('alreadyPrintLabel') }}</span>
        </v-tooltip>
      </v-layout>
      <v-layout v-if="item.isForecastedPackages">
        <v-tooltip top>
          <template v-slot:activator="data">
            <div v-on="data.on"><v-icon>widgets</v-icon></div>
          </template>
          <span>{{ $t('isThePackage') }}</span>
        </v-tooltip>
        <v-tooltip top v-if="item.isForecastedSplitShipment">
          <template v-slot:activator="data">
            <div v-on="data.on"><v-icon class="ml-1">open_with</v-icon></div>
          </template>
          <span>{{ $t('isTheNeedOpenPackage') }}</span>
        </v-tooltip>
      </v-layout>
    </td>
    <td class="text-xs-left">
      <v-layout v-for="(product, index) in item.products" :key="'product' + index">
        <v-flex xs12 v-if="!product.isPackageManagement">
          <ProductWidget
            :name="getUpcName(product)"
            :condition="product.condition"
            :upc="product.upc"
            :pickedUpcs="pickedUpcs"
            :asin="isOrganization ? product.asin : null"
            :orderId="isWarehouse ? null : product.relatedOrder"
          >
            <template v-slot:info>
              <v-flex class="text-xs-right" style="white-space: nowrap">
                {{ product.toShip }}
                <div style="display: inline-block; width: 18px">
                  <v-icon
                    small
                    style="cursor: pointer"
                    v-if="type === 'active' && pickedUpcs.includes(product.upc)"
                    @click.stop="cancelPickedItem(product)"
                    >pan_tool</v-icon
                  >
                </div>
              </v-flex>
            </template>
            <template v-slot:upc>
              <span class="ml-2"
                ><a @click.stop="$emit('clickUpc', product.upc)">{{ product.upc }}</a></span
              >
            </template>
          </ProductWidget>
        </v-flex>
        <v-flex xs12 v-if="product.isPackageManagement">
          <v-layout justify-space-between align-center>
            <v-layout class="text-sm-left">
              {{ product.upc }}
            </v-layout>
            <v-flex class="text-xs-right" style="white-space: nowrap">
              {{ product.toShip }}
              <div style="display: inline-block; width: 18px">
                <v-icon
                  small
                  style="cursor: pointer"
                  v-if="type === 'active' && pickedUpcs.includes(product.upc)"
                  @click.stop="cancelPickedItem(product)"
                  >pan_tool</v-icon
                >
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout v-if="getService(item).length || (item.IMEIRecords && item.IMEIRecords.length)">
        <span>{{ $t('otherServices') }}:</span>
        <v-chip v-for="service in getService(item)" :key="service" class="text-capitalize">{{
          (otherServices.find(singleService => service.toLowerCase() === singleService.value.toLowerCase()) || {}).displayName || service
        }}</v-chip>
        <v-chip v-if="item.IMEIRecords && item.IMEIRecords.length">IMEI</v-chip>
      </v-layout>
  
      <v-layout v-if="item.warehouseNote && item.warehouseNote.length">
        <v-layout column>
          <div>
            <b>{{ $t('warehouseNote') }}:</b>
          </div>
          <div style="whitespace: pre-wrap; overflow-wrap: break-word; max-width: 30vw">
            {{ item.warehouseNote }}
          </div>
        </v-layout>
      </v-layout>
    </td>
    <td class="text-xs-left" v-if="isOrganization">
      <div class="shipment-id">{{ item.shipmentId }}</div>
    </td>
    <td class="text-xs-left">
      <div class="shipment-id">{{ type === 'canceled' && item.cancelReason ? item.cancelReason : item.trackingNum }}</div>
      <v-layout v-if="isWarehouse && type === 'active'">
        <div v-if="displayLabelSource(item) === 1" class="label-source label-source--vite">V</div>
        <div v-if="displayLabelSource(item) === 0" class="label-source label-source--upload">U</div>
        <v-icon pl-2 v-if="displayScanForm(item)" small>barcode_reader</v-icon>
      </v-layout>
    </td>
    <td class="text-xs-center">{{ item.packageQty }}</td>
    <td class="text-xs-left" v-if="isOrganization">
      {{
        item.destination && (item.destination.name === '-- Other --' ? item.destination.content : item.destination.name)
      }}
    </td>
    <td class="text-xs-left">
      <v-layout 
        row 
        wrap 
        v-for="(time, i) in getColumnTimes(item)"
        :key="i"
      >
        {{ toTimestampString(time) }}
      </v-layout>
    </td>

    <td v-if="type === 'active' && !isHideBtns">
      <v-layout justify-center wrap :class="{'compact-actions': compact}">
        <v-btn
          color="primary"
          v-if="item.isMeasureDimension && isOrganization"
          :disabled="!item.dimensions"
          flat
          icon
          @click.stop="$emit('show-dimension-dialog', item)"
        >
          <v-icon>edit</v-icon>
          <v-badge class="editDimensionBadge" :value="checkNewDimensionChange(item)" color="red">
            <template v-slot:badge>
              <span class="badge">{{ $t('new') }}</span>
            </template>
          </v-badge>
        </v-btn>
        <v-tooltip top>
          <template v-slot:activator="tooltip">
            <div v-on="tooltip.on">
              <v-btn color="primary" flat icon @click.stop="getShipmentLabel(item)" :disabled="!item.zipFile"
                ><v-icon :color="item.isDownloaded ? 'success' : ''">cloud_download</v-icon></v-btn
              >
            </div>
          </template>
          {{ $t(item.isDownloaded ? 'reDownload' : 'download') }}
        </v-tooltip>
        <v-tooltip top v-if="isWarehouse">
          <template v-slot:activator="tooltip">
            <div v-on="tooltip.on">
              <v-btn
                color="primary"
                flat
                icon
                @click.stop="printShipmentLabel(item)"
                :disabled="!item.zipFile || !checkItemCanPrint(item)"
                ><v-icon :color="item.isPrinted ? 'success' : ''">print</v-icon></v-btn
              >
            </div>
          </template>
          {{ $t(item.isPrinted ? 'rePrint' : 'print') }}
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="tooltip">
            <div v-on="tooltip.on">
              <v-badge :value="checkNewComment(item)" color="red" overlap v-if="isOrganization">
                <template v-slot:badge>
                  <span class="badge">{{ $t('new') }}</span>
                </template>
                <v-btn color="primary" flat icon @click.stop="$emit('show-comments-active', item)"
                  ><v-icon>business</v-icon></v-btn
                >
              </v-badge>
            </div>
          </template>
          {{ $t('InternalOrganizations') }}
        </v-tooltip>
        <v-tooltip top v-if="isOrganization || item.applyForCancelShipment">
          <template v-slot:activator="tooltip">
            <div v-on="tooltip.on">
              <LoaderButton
                buttonIcon="delete"
                color="secondary"
                :promiseAwait="cancelShipment"
                :promiseItem="item"
                :flat="true"
              />
            </div>
          </template>
          {{ $t('cancel') }}
        </v-tooltip>
        <v-tooltip top v-if="!isOrganization || item.userKey === $store.getters.activeOrganization">
          <template v-slot:activator="tooltip">
            <div v-on="tooltip.on">
              <v-btn
                color="primary"
                v-if="item.isMeasureDimension && !item.isApproveShipment"
                :disabled="isOrganization && !item.dimensions"
                flat
                icon
                @click.stop="$emit('show-dimension-dialog', item)"
              >
                <v-icon>edit</v-icon>
                <v-badge
                  class="editDimensionBadge"
                  :value="!!(item.dimensions && item.dimensions.length) && isOrganization"
                  color="red"
                >
                  <template v-slot:badge>
                    <span class="badge">{{ $t('new') }}</span>
                  </template>
                </v-badge>
              </v-btn>
              <v-btn
                v-else
                color="primary"
                :disabled="isWarehouseOutboundDisabled || (item.isMeasureDimension && !item.isApproveShipment)"
                flat
                :loading="item.isProcessing"
                icon
                @click.stop="$emit('show-confirm-dialog', item)"
                ><v-icon>check_circle</v-icon></v-btn
              >
            </div>
          </template>
          {{ $t(`${item.isMeasureDimension && !item.isApproveShipment ? 'measureDimension' : 'confirm'}`) }}
        </v-tooltip>
      </v-layout>
    </td>
    <td v-if="(type === 'history' || type === 'canceled') && !isHideBtns" class="text-xs-center">
      <v-layout justify-center wrap>
        <v-tooltip top>
          <template v-slot:activator="tooltip">
            <div v-on="tooltip.on">
              <v-btn color="primary" flat icon @click.stop="$emit('show-details', item)"
                ><v-icon>folder_open</v-icon></v-btn
              >
            </div>
          </template>
          {{ $t('details') }}
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="tooltip">
            <div v-on="tooltip.on">
              <v-btn color="primary" flat icon @click.stop="$emit('show-comments-history', item)" v-if="isOrganization"
                ><v-icon>business</v-icon></v-btn
              >
            </div>
          </template>
          {{ $t('InternalOrganizations') }}
        </v-tooltip>
        <v-tooltip top v-if="type === 'canceled'">
          <template v-slot:activator="tooltip">
            <div v-on="tooltip.on">
              <v-btn
                color="primary"
                flat
                :disabled="item.isForecastedPackages"
                icon
                @click.stop="
                  $emit('copy-shipment', {
                    ...item,
                    isInitCanceledShipment: type === 'canceled',
                  })
                "
                v-if="isOrganization"
                ><v-icon>content_copy</v-icon></v-btn
              >
            </div>
          </template>
          {{ $t('CopyShipment') }}
        </v-tooltip>
      </v-layout>
    </td>
    <td v-if="$slots.extraColumn">
      <slot name="extraColumn"></slot>
    </td>
  </tr>
</template>

<script>
import LoaderButton from './LoaderButton'
import ProductWidget from './ProductWidget'
import {timeTools, splitTrackingNum} from '@/utils/tools'

export default {
  name: 'OutboundShipmentRow',
  components: {
    LoaderButton,
    ProductWidget
  },
  mixins: [timeTools],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    isOrganization () {
      return !!this.$store.getters.activeOrganization
    },
    isWarehouse () {
      return !!this.$store.getters.activeWarehouse
    },
    organizationKeyToId () {
      return this.$store.getters.organizationKeyToId
    },
    userName () {
      return this.$store.getters.userExtra.name
    },
    otherServices () {
      return this.$store.getters.otherServices
    },
    warehouseLimitInfo () {
      return this.$store.getters.warehouseLimitedInfo || {}
    }
  },
  methods: {
    toggleHighlight (item) {
      return this.updateShipments({docKey: item._key, isCollection: !item.isCollection})
    },
    getColumnTimes (item) {
      return this.type === 'canceled' 
        ? [item.createTime, item.deleteTime] 
        : [item.shipmentCreateTime, item.createTime]
    },
    checkNewDimensionChange (item) {
      return !!item.dimensions?.length && item.isNeedHandler && this.isOrganization
    },
    async updateShipments (item) {
      return this.$store.dispatch('updateShipments', item)
    },
    splitTrackingNum,
    getOrgId (tenantKey = '') {
      return this.organizationKeyToId.get(tenantKey) || ''
    },
    getUpcName (product) {
      const {name, upc} = product
      if (this.isWarehouse) return this.$store.getters.getUpcName(upc)
      return name
    },
    checkItemCanPrint (item) {
      const path = item.zipFile.split('/')
      let fileName = path[path.length - 1]
      return fileName.endsWith('.pdf')
    },
    getShipmentLabel (item) {
      let path = item.zipFile.split('/')
      let fileName = path[path.length - 1]
      if (item.zipFile) {
        this.$store.dispatch('downloadFile', {fullPath: item.zipFile, name: fileName})
        if (this.isWarehouse) return this.updateShipments({docKey: item._key, isDownloaded: true})
      }
    },
    printShipmentLabel (item) {
      let path = item.zipFile.split('/')
      let fileName = path[path.length - 1]
      if (item.zipFile) {
        this.$store.dispatch('printFile', {fullPath: item.zipFile, name: fileName})
        return this.updateShipments({docKey: item._key, isPrinted: true, printedTime: new Date()})
      }
    },
    cancelShipment (item) {
      if (item.isPrinted && this.isOrganization) {
        if (confirm(this.$t('cancelShipmentApplication'))) {
          return this.updateShipments({docKey: item._key, applyForCancelShipment: true})
        }
      } else if (confirm(this.$t((item.labels && item.labels.length > 0) ? 'cancelShipment' : 'cancelShipmentNoItem'))) {
        if (item.applyForCancelShipment) {
          item.applyForCancelShipment = false
        }
        return this.$store.dispatch('cancelShipment', item)
      }
      return Promise.resolve()
    },
    checkNewComment (request) {
      let lastReadTime = request[`lastRead_draftComments_${this.$store.getters.uid}`]
      let hasOnlyInitialComment = request.draftComments && request.draftComments.length === 1 && request.draftComments[0].initialComment
      let lastMessageTime = request.draftComments && request.draftComments.length > 0 && request.draftComments.slice(-1)[0].createTime
      return !hasOnlyInitialComment && !!lastMessageTime && (!lastReadTime || lastReadTime < lastMessageTime)
    },
    async cancelPickedItem ({ upc }) {
      if (
        this.loading || 
        !this.item || 
        !confirm(this.$t('confirmCancelPickup'))
      ) return
      this.loading = true
      try {
        await this.$store.dispatch('cancelPickedItem', {
          cancelPickedItem: this.item,
          upc
        })
        this.loading = false
      } catch (err) {
        alert(this.$t('sthBroke'))
        console.log(err)
        this.loading = false
      }
    },
    getService (item) {
      const {confirmedOtherServices = [], otherServices = []} = item
      return this.type === 'history' ? confirmedOtherServices : otherServices
    },
    displayScanForm (item) {
      const {labels = []} = item
      if (!labels.length) return false
      const allowScanFormShipments = this.$store.getters.waitingScanFormShipments || []
      const targetShipment = allowScanFormShipments.find(shipment => shipment.shipmentId === item._key)
      if (!targetShipment) return false
      return true
    },
    displayLabelSource (item) {
      const isLabel = item.labels && item.labels.length > 0
      if (isLabel) return 1
      return 0
    }
  },
  props: {
    props: Object,
    item: Object,
    index: Number,
    expanded: Boolean,
    type: String,
    siteName: String,
    pickedUpcs: Array,
    isHideBtns: {
      type: Boolean,
      default: false
    },
    isHideCheckBox: {
      type: Boolean,
      default: false
    },
    isWarehouseOutboundDisabled: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    isHideStar: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.editDimensionBadge .v-badge__badge {
  font-size: 10px;
  left: -6px;
  top: -23px;
}
.thinBox .input-group__input {
  border: 1px solid rgba(0,0,0,.54) !important;
}
.text-capitalize .v-chip__content {
  text-transform: capitalize !important;
}
.shipment-id {
  max-width: 220px;
  overflow-wrap: break-word;
}

.outbound.confirm .v-input--selection-controls {
  margin-top: 0px !important;
}
.outbound.confirm .container {
  padding: 0px 12px !important;
}

.badge {
  font-size: 10px;
}
.exception-shipment {
  background-color: red;
}

.compact-row td {
  padding: 4px 8px !important;
}

.compact-actions {
  gap: 4px !important;
}

.compact-actions .v-btn {
  margin: 0 !important;
}

.compact-cell {
  font-size: 0.9em;
}

.compact-layout {
  margin: 2px 0 !important;
}

.compact-layout .v-icon {
  font-size: 18px !important;
}

.compact-layout .v-btn {
  width: 24px;
  height: 24px;
  margin: 0 2px !important;
}

.compact-layout .v-chip {
  height: 24px !important;
  margin: 2px !important;
}

.highlight-icon {
  cursor: pointer;
  opacity: 0.3;
  transition: all 0.3s;
}

.highlight-icon:hover {
  opacity: 0.7;
}

.label-source {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  margin-right: 4px;
}

.label-source--vite {
  background-color: #4CAF50;
  color: white;
}

.label-source--upload {
  background-color: #2196F3;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/OutboundShipmentRow.vue